export const stringifyPolygon = (polygon) =>
  polygon.reduce((key, coordinate) => `${key}${coordinate.lat}${coordinate.lng}`, '');
